import { schema } from 'normalizr';

export const variableSchema = new schema.Entity('variables');

export const discountDefSchema = new schema.Entity('discountDefs', {
  formula: {
    variables: [variableSchema],
  },
});
